/* eslint-disable react/prop-types */
import React from "react";
import Gallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "../Styles/Components/UrunCarousel.css";
const ImageCarousel = ({ images }) => {
  const galleryImages = images.map((img) => ({
    original: img,

    thumbnail: img, // Küçük önizleme resmi
    // description: 'Image description', // İsterseniz açıklama ekleyebilirsiniz
  }));

  return (
    <div className="carousel-container">
      <Gallery
        items={galleryImages}
        showPlayButton={false}
        // disableThumbnailScroll={true}
        autoPlay={false}
        on
      />
    </div>
  );
};

export default ImageCarousel;
